// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// import { Error } from '../Typography.jsx';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import Table from '../Table.jsx';

import { fetchDispensaryHistory } from '../../actions/pharmacyActions';

type Props = {
  dispensaryHistory: Object[],
  fetchDispensaryHistory: Function,
}

class DispensaryHistoryPageComponent extends Component<Props> {
  componentDidMount() {
    this.props.fetchDispensaryHistory();
  }

  render() {
    const columns = [
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
      },
      {
        Header: 'Time',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format('HH:mm') : '--'),
      },
      {
        Header: 'Drug Name',
        id: 'drugName',
        cell: item => item.drugName || '--',
      },
      {
        Header: 'Location',
        id: 'location',
        cell: item => item.location || '--',
      },
      {
        Header: 'In',
        id: 'quantityIn',
        cell: item => item.quantityIn || '0',
      },
      {
        Header: 'Out',
        id: 'quantityOut',
        cell: item => item.quantityOut || '0',
      },
    ];

    return (
      <div>
        <PageHeader title='Dispensary Report' />
        <ContentBox>
          <Table
            columns = { columns }
            data = { this.props.dispensaryHistory || [] }
            style={{}}
          />
        </ContentBox>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dispensaryHistory: state.pharmacy.data.dispensaryHistory,
});

const mapDispatchToProps = dispatch => ({
  fetchDispensaryHistory: () => dispatch(fetchDispensaryHistory()),
});

const DispensaryHistoryPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DispensaryHistoryPageComponent);

export default DispensaryHistoryPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/DispensaryHistoryPage.jsx